<template>
  <div class="phone-index marketing">
    <div class="title-box">
      <span class="text1">展业中心</span>
    </div>
    <div class="empty-box" style="height:70px">我的客户</div>
    <div class="empty-box" style="height:60px">日程提醒</div>
    <div class="empty-box" style="height:60px">最新访客</div>
    <div class="tools-list3" v-if="list.length">
      <div class="tools-title">展业工具</div>
      <draggable class="list" v-model="list" @update="sortEvent" @drop.native.stop>
        <div class="tools-item" v-for="(bean,i) in list" :key="i" v-if="bean">
          <img :src="bean.img" alt="">
          <span class="text1">{{bean.name}}</span>
          <div class="text2">{{bean.description.substr(0,11)}}</div>
        </div>
      </draggable>
    </div>
    <phoneNav active="marketing"></phoneNav>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import phoneNav from "./phoneNav";
export default {
  components: {
    phoneNav,
    draggable,
  },
  mixins:[],
  props: {
  },
  data() {
    return {
      list:[],
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
  },
  methods: {
    setData(list){
      this.list = list.filter(item=>{
        return item.enable==1
      });;
    },
    sortEvent(){
      console.log("sortEvent",this.list)
      const ids = this.list.filter(item=>{
        return item
      }).map(item=>{
        return item.id;
      })
      this.$http({
        url: "/buz/mcmMerchantModule/updateRank",
        type: "POST",
        data: {
          ids:ids.join(',')
        }
      }).then((res)=>{
        this.$emit("sort", this.list);
      })
    },
  },

};
</script>
<style lang="scss" scoped>
@import "./phoneIndex.scss";
</style>
